import { __exports as getOptionsFromElement } from "./index183.js";
import { __require as requireOptionsFromStrings } from "./index118.js";
import { __require as requireDefaults } from "./index121.js";
var hasRequiredGetOptionsFromElement;
function requireGetOptionsFromElement() {
  if (hasRequiredGetOptionsFromElement) return getOptionsFromElement;
  hasRequiredGetOptionsFromElement = 1;
  Object.defineProperty(getOptionsFromElement, "__esModule", {
    value: true
  });
  var _optionsFromStrings = requireOptionsFromStrings();
  var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);
  var _defaults = requireDefaults();
  var _defaults2 = _interopRequireDefault(_defaults);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getOptionsFromElement$1(element) {
    var options = {};
    for (var property in _defaults2.default) {
      if (_defaults2.default.hasOwnProperty(property)) {
        if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
          options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
        }
        if (element.hasAttribute("data-" + property.toLowerCase())) {
          options[property] = element.getAttribute("data-" + property.toLowerCase());
        }
      }
    }
    options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");
    options = (0, _optionsFromStrings2.default)(options);
    return options;
  }
  getOptionsFromElement.default = getOptionsFromElement$1;
  return getOptionsFromElement;
}
export {
  requireGetOptionsFromElement as __require
};
//# sourceMappingURL=index148.js.map
